
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import { MailConfig } from '@/installationConfig';
import { formatCurrency } from '@/helpers/currency';

import {
  ContactsClient,
  ContactsLookupQuery,
  DataSourceLoadOptionsBase,
  IContactListItemDto,
  MailTemplatesClient,
  MailTemplateType,
  IMailTemplateDto,
  ProjectContactsClient,
  IMailInvoiceCommand,
  IInvoiceDto,
  InvoicesClient,
  MailInvoiceCommand,
  ProjectsClient,
  ProjectBasicInfoDto,
  AssignedContact,
  ProgressStatementExportType,
} from '@/data/web-api-client';

import { DxForm, DxSimpleItem, DxRequiredRule, DxEmailRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxHtmlEditor } from 'devextreme-vue/html-editor';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxScrollView,
    DxRequiredRule,
    DxEmailRule,
    DxHtmlEditor,
  },
})
export default class MailPopup extends Vue {
  show: boolean = false;
  sending: boolean = false;
  fullscreen: boolean = false;
  formdata: IMailInvoiceCommand | any = {
    template: '',
    sendSms: true,
    from: '',
    to: [],
    cc: [],
    subject: '',
    content: '',
    objectIds: [],
    language: '',
  };

  templates: IMailTemplateDto[] = [];
  project: ProjectBasicInfoDto | null = null;

  @Prop({ required: true })
  invoice!: IInvoiceDto;

  @Prop({ required: false, default: ProgressStatementExportType.None })
  progressStatementExportType!: ProgressStatementExportType;

  @Prop({ required: false, default: '' })
  progressStatementDocumentNumber!: string;

  public async open() {
    this.formdata.to.splice(0, this.formdata.to.length);
    this.formdata.cc.splice(0, this.formdata.cc.length);
    this.loadProjectContacts();
    this.loadProject();

    if (this.invoice.customerContact && this.invoice.customerContact.email && this.invoice.customerContact.email !== '') {
      (this.formdata.to as string[]).push(this.invoice.customerContact.email);
    } else if (this.invoice.customer && this.invoice.customer.email && this.invoice.customer.email !== '') {
      (this.formdata.to as string[]).push(this.invoice.customer.email);
    }

    this.formdata.objectIds.push(this.invoice.id);

    const lastUsedEmail = localStorage.getItem('invoice_last_used_email');
    const lastUsedTemplate = localStorage.getItem('invoice_last_used_template');
    if (lastUsedEmail) {
      this.formdata.from = lastUsedEmail;
    } else {
      this.formdata.from = this.currentUser.username;
    }

    if (lastUsedTemplate) {
      this.formdata.template = lastUsedTemplate;
      const template = this.templates.find((o) => o.name === lastUsedTemplate);
      if (template) {
        this.formdata.subject = template.subject ?? '';
        this.formdata.content = template.content ?? '';
        this.formdata.language = template.language ?? '';
        this.replaceTags();
      }
    }

    this.show = true;
  }

  async loadProject() {
    if (!this.invoice.projectId || this.invoice.projectId === '') {
      return;
    }

    this.project = await new ProjectsClient(undefined, this.$axios).getProjectBasicInfo(this.invoice.projectId);

    this.replaceTags();
  }

  async loadProjectContacts() {
    if (!this.invoice.projectId || this.invoice.projectId === '') {
      return;
    }

    const res = await new ProjectContactsClient(undefined, this.$axios).getContacts(this.invoice.projectId);
    res.forEach((contact) => {
      if (contact.sendInvoice && contact.contact && contact.contact.email && contact.contact.email !== '') {
        if (this.formdata.to.indexOf(contact.contact.email) === -1) {
          this.formdata.to.push(contact.contact.email);
        }
      }
    });
  }

  async created() {
    try {
      this.templates = await new MailTemplatesClient(undefined, this.$axios).getAll(MailTemplateType.Invoicing);
    } catch {
      // do nothing
    }
  }

  replaceTags() {
    try {
      let contact = null;
      if (this.invoice) {
        if (this.invoice.customerContact) {
          contact = this.invoice.customerContact;
        } else if (this.invoice.customer) {
          contact = this.invoice.customer;
        }
      }

      this.formdata.content = this.formdata.content.replaceAll('#CurrentDate', new Date().toLocaleDateString());

      if (this.invoice.dueDate) {
        this.formdata.content = this.formdata.content.replaceAll('#DaysOverdue', Math.round((new Date().getTime() - this.invoice.dueDate.getTime()) / (24 * 3600 * 1000)));
      }

      this.formdata.content = this.formdata.content.replaceAll('#Date', this.invoice.date ? this.invoice.date.toLocaleDateString() : '');

      this.formdata.content = this.formdata.content.replaceAll('#DueDate', this.invoice.dueDate ? this.invoice.dueDate.toLocaleDateString() : '');

      this.formdata.content = this.formdata.content.replaceAll('#Total', this.invoice.total ? formatCurrency(this.invoice.total) : '');

      if (this.formdata.content.indexOf('#WarfAddress') !== -1 && this.project && this.project.address) {
        this.formdata.content = this.formdata.content.replaceAll('#WarfAddress', `${this.project.address.addressline1}, ${this.project.address.zip} ${this.project.address.city}`);
      }
      this.formdata.content = this.formdata.content.replaceAll('#WarfAddress', this.invoice.total ? formatCurrency(this.invoice.total) : '');

      while (this.formdata.content.indexOf('#Name') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Name', contact ? contact.displayName : '');
      }

      while ((this.formdata.content as string).indexOf('#DocumentNumber') !== -1) {
        this.formdata.content = this.formdata.content.replace('#DocumentNumber', this.invoice.documentNumber);
      }

      while ((this.formdata.subject as string).indexOf('#DocumentNumber') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#DocumentNumber', this.invoice.documentNumber);
      }

      if (contact && contact.type === 'Contact') {
        const splittedName = contact.displayName ? contact.displayName.split(' ') : null;
        if (splittedName && splittedName.length > 0) {
          const firstname = splittedName[0];
          const lastname = contact.displayName!.replace(firstname, '');

          while (this.formdata.content.indexOf('#Contact_Firstname') !== -1) {
            this.formdata.content = this.formdata.content.replace('#Contact_Firstname', firstname);
          }

          while (this.formdata.content.indexOf('#Contact_Lastname') !== -1) {
            this.formdata.content = this.formdata.content.replace('#Contact_Lastname', lastname);
          }
        }
      }
      while (this.formdata.content.indexOf('#Contact_Firstname') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Contact_Firstname', '');
      }

      while (this.formdata.content.indexOf('#Contact_Lastname') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Contact_Lastname', '');
      }

      while (this.formdata.content.indexOf('#Project_Name') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Project_Name', this.invoice.projectName);
      }
      while (this.formdata.subject.indexOf('#Project_Name') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#Project_Name', this.invoice.projectName);
      }

      while (this.formdata.subject.indexOf('#Project_DocumentNumber') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#Project_DocumentNumber', this.invoice.projectNumber);
      }

      while (this.formdata.content.indexOf('#Project_DocumentNumber') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Project_DocumentNumber', this.invoice.projectNumber);
      }
    } catch {
      // do nothing
    }
  }

  async send() {
    try {
      if (this.formdata.from) {
        localStorage.setItem('invoice_last_used_email', this.formdata.from);
        localStorage.setItem('invoice_last_used_template', this.formdata.template);
      }

      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      this.formdata.exportType = this.progressStatementExportType;
      this.formdata.progressStatementDocumentNumber = this.progressStatementDocumentNumber;

      this.sending = true;
      // TO KEEP MAIL FORMAT CORRECT, REPLACE P-TAG WITH DIV-TAG
      this.formdata.content = this.formdata.content.replaceAll('<p>', '<div>').replaceAll('</p>', '</div>');
      await new InvoicesClient(undefined, this.$axios).mail(new MailInvoiceCommand(this.formdata));
      notificationService.showSuccessMessage('Mail verstuurd');
      this.$emit('mailSend');
      this.show = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.sending = false;
      this.progressStatementDocumentNumber = '';
      this.progressStatementExportType = ProgressStatementExportType.None;
    }
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'separator',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'separator',
          'orderedList',
          'bulletList',
          'separator',
          'link',
          'separator',
          {
            formatName: 'size',
            formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
          },
          {
            formatName: 'header',
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }

  get contactDataSource() {
    const client = new ContactsClient(undefined, this.$axios);
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          if (loadOptions.filter) {
            loadOptions.filter = undefined;
          }

          if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
            loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
          }

          const clients = await new ProjectsClient(undefined, this.$axios).getProjectsContacts(this.invoice.projectId!);

          return clients.filter((client) => !!client.contact?.email).map((client) => client.contact);
        },
        byKey: async (val: string) => {
          return await client.getBasicInfo(val);
        },
      }),
      paginate: this.invoice.projectId ? false : true,
    });
  }

  get contactOptions() {
    return {
      dataSource: this.contactDataSource,
      searchEnabled: true,
      remoteOperations: true,
      searchExpr: ['email', 'displayName'],
      acceptCustomValue: true,
      valueExpr: (item: any) => {
        if (!item) {
          return 'undefined';
        }

        if (typeof item === 'string') {
          return item;
        }

        return item.email;
      },
      displayExpr: (val: IContactListItemDto | string) => {
        if (!val) {
          return '';
        }

        if (typeof val === 'string') {
          return val;
        }

        if (!val.displayName) {
          return val.email;
        }
        return `${val.displayName} <${val.email}>`;
      },
      onCustomItemCreating: (args: any) => {
        args.customItem = args.text;
      },
    };
  }

  get fromOptions() {
    return {
      dataSource: [
        MailConfig.infoMailAddress,
        MailConfig.accountingMailAddress,
        MailConfig.executionMailAddress,
        MailConfig.invoicingMailAddress,
        MailConfig.calculationMailAddress,
        this.currentUser.username,
      ],
    };
  }

  get templateOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      onItemClick: (e: any) => {
        self.formdata.subject = e.itemData.subject;
        self.formdata.content = e.itemData.content;
        self.formdata.language = e.itemData.language;

        self.replaceTags();
      },
    };
  }
}
